import { TableViewTogglesViewType } from "@rio-cloud/rio-uikit";
import CustomState from "@rio-cloud/rio-uikit/CustomState";

export type DashboardTableComingSoonProps = {
  headline: string;
};

const textShort =
  "Este recurso chegará em breve. Fique atento às atualizações!";

const DashboardTableComingSoon = (props: DashboardTableComingSoonProps) => {
  const image = (
    <img
      className="max-width-500"
      src="https://cdn.rio.cloud/svg/dashboard/dashboard_coming_soon.svg"
      alt="Coming soon"
    />
  );
  return (
      <CustomState
        outerClassName='border-none'
        headline={props.headline}
        message={textShort}
        image={image}
      />
  );
};

export default DashboardTableComingSoon;
